import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import jspdf from 'jspdf';
import html2canvas from 'html2canvas';

import { Comissao, ComissaoProdutoPdf, ComissaoVendedor } from '../models/comissao';
import { ComissaoService } from '../comissao.service';
import { UserService } from 'src/app/core/services/user.service';


@Component({
  selector: 'app-comissao-list-pdf',
  templateUrl: './comissao-list-pdf.component.html',
  styleUrls: ['./comissao-list-pdf.component.scss']
})
export class ComissaoListPdfComponent implements OnInit {

  private idPedido: string = "0";
  private idUsuario: string = "0";
  public usuario: string = "Usuário não identificado";
  public itemComissao: ComissaoVendedor = {};
  public listaProduto: ComissaoProdutoPdf[] = [];

  public dataInicio: Date = new Date();
  public dataFim:  Date = new Date();
  public data:  Date = new Date();

  
  cols: any[];

  constructor(public comissaoService: ComissaoService, 
              private router: Router, 
              private route: ActivatedRoute, 
              private activateRoute: ActivatedRoute, 
              private userService: UserService) { }

  title = 'SIGEVE - Comissão do Vendedor';

  ngOnInit(): void {

    this.usuario = this.userService.getUserName(); 
    
    this.route.params.forEach((urlParams) => {
      this.idUsuario= urlParams['idUsuario'];
      this.dataInicio= urlParams['dtInicio'];
      this.dataFim=urlParams['dtFim'];

    });

    this.getComissao(this.idUsuario);
    this.getComissaoListaProduto(this.idUsuario);
  }


  generatePDF() {

    var data = document.getElementById('contentToConvert');
    
    html2canvas(data).then(canvas => {
      var imgWidth = 208;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jspdf('p', 'mm', 'a4');
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
      pdf.save('SIGEVE_COMISSAO_' + this.itemComissao.vendedor + '_'+this.data + '.pdf');
    });
  }

  getComissao(idUsuario: string) {

    this.comissaoService.getComissao(idUsuario, this.dataInicio, this.dataFim ).subscribe(
      (res) => {
        if (res) {
          this.itemComissao = res;
        }
      },
      err => {
        console.log("ERRO PDF-PEDIDO: " + err);
      }
    );
  }

  getComissaoListaProduto(idUsuario: string) {

    this.comissaoService.getComissaoProdutoLista(idUsuario, this.dataInicio, this.dataFim).subscribe(
      (res) => {
        if (res) {
          this.listaProduto = res;
        }
      },
      err => {
        console.log("ERRO PDF-PEDIDO-PRODUTO: " + err);
      }
    );
  }

  backClick() {
    this.router.navigate(['/comissao-list']) 
    
  }

}